import React from 'react';
import styles from './ActiveSwitch.module.scss';
import cn from 'classnames';
import { Tooltip } from 'antd';

const ActiveSwitch = ({ value, onChange }) => {
  return (
    <div className={styles.root}>
      <Tooltip title="Все отключения">
        <div
          className={cn(styles.content, {
            [styles.active]: !value,
          })}
          onClick={() => onChange(false)}
        >
          Все
        </div>
      </Tooltip>

      <Tooltip title="Только активные отключения">
        <div
          className={cn(styles.content, {
            [styles.active]: value,
          })}
          onClick={() => onChange(true)}
        >
          Только активные
        </div>
      </Tooltip>
    </div>
  );
};

export default ActiveSwitch;
